export let eventObj: any = {};

export const updateEventObj = (obj: any) => {
    if (obj && obj.key) {
        eventObj = obj
    } else {
        eventObj = {}
    }
};